export const TABLE_CELL_EDIT_BUTTON_SIZE = 24
